import React from 'react'
import { Avatar, Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';


export default function RatingsAndReviews({ type, productId }) {
    return (
        <div>
            {/* <div className="mx-3 mb-4 md:ml-0 px-3 py-2 bg-white rounded shadow"> */}
            <div className="ml-3 mr-3 my-3 p-3 md:ml-0 bg-white rounded shadow pb-3">
                <div className="mx-3 flex flex-row justify-between border-b border-gray-200">
                    <p className="text-2xl font-semibold text-gray-700">Reviews & Ratings</p>
                    <div className="hidden md:block ">
                        <Button type="dashed" >Write a Review</Button>
                    </div>
                    <div className="md:hidden">
                        <Button 
                            type="dashed"
                            className="rounded"
                            icon={<EditOutlined />} 
                        >
                        </Button>
                    </div>
                </div>
                
                <div className="px-3">
                    <section className="mt-6 border-b border-gray-200 last:border-b-0">
                        <div className="flex items-start">
                            <Avatar shape="square" size={55} style={{backgroundColor: "#f56a00"}}>
                                S
                            </Avatar>
                            <div className="ml-3">
                                <div className="ml-2 text-sm text-gray-500">
                                    Saurabh Singh, 2 months ago
                                </div>

                                <div className="mx-2 my-1 flex leading-5">
                                    <span className="mr-2 text-sm text-gray-800 font-bold">Brilliant !!!</span>
                                    <span className="flex items-center bg-green-600 text-white rounded px-1 text-center text-sm">4.1<svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg></span>
                                </div>

                                <div className="mx-2 my-1 flex">
                                    <div className="text-gray-700">
                                        Acha chl rha hai hmara ye tractor.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="mt-6 border-b border-gray-200 last:border-b-0">
                        <div className="flex items-start">
                            <Avatar shape="square" size={55} style={{backgroundColor: "#ffbf00"}}>
                                U
                            </Avatar>
                            <div className="ml-3">
                                <div className="ml-2 text-sm text-gray-500">
                                    Umesh Yadav, 2 months ago
                                </div>

                                <div className="mx-2 my-1 flex leading-5">
                                    <span className="mr-2 text-sm text-gray-800 font-bold">Brilliant !!!</span>
                                    <span className="flex items-center bg-green-600 text-white rounded px-1 text-center text-sm">4.1<svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg></span>
                                </div>

                                <div className="mx-2 my-1 flex">
                                    <div className="text-gray-700">
                                        Acha chl rha hai hmara ye tractor.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    

                    <section className="m-5 flex justify-center md:hidden">
                        <Button type="dashed" >Write a Review</Button>
                    </section>
                </div>

            </div>
        </div>
    )
}
